import Loader from "Components/Loader";
import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import utils from "utils";
import api from "utils/api";
import NewBill from "./NewBill";
import "./Billing.scss";
function EditBilling(props) {
  const [loader, setLoading] = useState(true);
  const [editData,setEditData]=useState({});
  const [formActionState, formAction] = useState(false);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    fetchBillingDetails();
  }, []);
  function fetchBillingDetails() {
    const billing_id = location.state?.billing_id;
    if (!billing_id) {
      history.push(`${props.user_details.baseUrl}/billing`);
    } else {
      const query = new URLSearchParams({
        billing_id:billing_id
      }).toString();
      api
        .fetchEditBillingDetails(query)
        .then((response) => {
          if (response.data.status === 200) {
            const result = response.data.data.results[0];
            setEditData(result);
          } else {
            message.error(response.data.status);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }
  return (
    <div className="billing">
      {loader ? (
        <Loader />
      ) : (
        <>
          <div
            onClick={() => {
              history.push(`${props.user_details.baseUrl}/billing`);
            }}
            className="previous-page-button"
          >{`< Back To Previous Page`}</div>
          {editData &&<NewBill formAction={formAction} editData={editData} submitButtonAction={()=>{history.push(`${props.user_details.baseUrl}/billing`);}}/>}
        </>
      )}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer?.user_details,
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(EditBilling);
